/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { INCLUDE_TIME_BASED_ANALYSIS } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm, MODEL_TYPE_1_ID } from '#src/js/constants/models/modelTypes/index.js';
import RepairCostBreakdownSection from './RepairCostBreakdownSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form, modelType } = ownProps;
  const { selectFormValues } = modelTypesByForm[form];

  const showAverageAnnual =
    !!selectFormValues(state, INCLUDE_TIME_BASED_ANALYSIS) || modelType === MODEL_TYPE_1_ID;

  return {
    showAverageAnnual,
  };
};

export default connect(mapStateToProps)(RepairCostBreakdownSection);
